//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['market', 'event', 'isLimited', 'compact', 'keepOpen', 'outcomesLimit'],
  data() {
    return {
      competitions: [],
      events: [],
      defaultFilter: null,
      selectedFilter: null,
      filters: [],
      loading: true
    }
  },
  computed: {
      show() {
        if(this.keepOpen) return true;
        if(this.compact) {
          if(this.outrightMarketId == _.get(this.market, 'id')) {
            return true;
          }
          return false;
        }
        return true
      },
      outrightMarketId: {
        get() {
          return this.$store.state.outrightMarketId
        },
        set(value) {
          this.$store.commit('setOutrightMarketId', value)
        }
      }
  },
  mounted() {
    this.loading = true
  },
  methods: {
    toggle: function () {
      this.$store.commit('setOutrightMarketId', this.market.id)
    },
    toggleClose: function () {
      this.$store.commit('setOutrightMarketId', null)
    },
    getURL: function () {
      return this.localePath({
        name: 'sport-competition-outrights-id', params: {
          sport: this.$route.params.sport,
          competition: this.$route.params.competition,
          id: this.event.id,
        },
        query: {
          marketId: this.market.id,
        }
      })
    },
  }
}
